import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchTrainingStatus() {
      return new Promise((resolve, reject) => {
        axios
          .get('/training/trainingStatus')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateTrainingStatus(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/training/activateTraining?id=${data.id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    activateFFTModel(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/training/activateFFTModel?id=${data.id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteTrainingStatus(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/training/trainingStatus?id=${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
